import { Flower2 } from "lucide-react";
import { SectionHeading } from "./shared";

export default function ElementsSection({ t }) {
  return (
    <section className="bg-[#FAF5EE] py-16 sm:py-24 lg:py-32" data-testid="weddings-elements">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
        <SectionHeading eyebrow={t.elementsEyebrow} title={t.elementsTitle} />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {t.elements.map((el, i) => (
            <div key={i} className="bg-white p-4 sm:p-7 border border-[#EFE4D2] rounded-sm hover:shadow-lg hover:border-[#C9A87C] transition-all duration-500"
                 data-testid={`weddings-element-${i}`}>
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#F5EDE0] flex items-center justify-center mb-3 sm:mb-4">
                <Flower2 className="w-4 h-4 sm:w-5 sm:h-5 text-[#8B6F47]" strokeWidth={1.5} />
              </div>
              <h3 className="text-sm sm:text-base font-medium text-[#1F1815] mb-1.5 sm:mb-2">{el.title}</h3>
              <p className="text-xs sm:text-sm text-[#6B5D4F] leading-relaxed font-light">{el.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
